<template>
  <div id="main-page">
    <section-definition title="Manager Home"></section-definition>




    <v-dialog v-model="showGrade" max-width="900px" attach="#main-page" >
      <view-grade
              v-if="showGrade"
              :graded_lead="selectedLead"
              @close-parent="showGrade=false"
      ></view-grade>
    </v-dialog>


     <v-dialog v-model="editGrade" max-width="1200px" persistent >
        <div style="background-color: white">
           <div style="justify-content: flex-end; display: flex; margin-bottom: -20px">
              <v-btn icon @click="close_edit_dialog()">
                 <v-icon>close</v-icon>
              </v-btn>
           </div>
           <edit-grade
               v-if=" editGrade"
               :grade_id="selectedLead._id"
               @close="close_edit_dialog()"

           />
        </div>

     </v-dialog>




     <!------------dialog to download data------------------------------------------------------------------------------>
    <v-dialog v-model="dialog_download" persistent max-width="500px" attach="#main-page">
      <v-card>
        <v-card-title>
          <span class="headline">Download Raw Data: {{download_type}}</span>
        </v-card-title>

        <v-card-text>
          <v-container fluid grid-list-md page>
            <v-layout wrap>

              <v-flex xs6>
                <v-menu
                        v-model="download_date_menu1"
                        :close-on-content-click="false"
                        :nudge-right="0"
                        lazy
                        transition="scale-transition"
                        offset-y
                        :nudge-bottom="0"
                        full-width
                        max-width="290px"
                        min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                            v-model="download_date_begin"
                            label="Begin Range"
                            hint="YYYY-MM-DD format"
                            prepend-icon="event"
                            v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                          v-model="download_date_begin"
                          no-title
                          @input="download_date_menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs6>
                <v-menu
                        v-model="download_date_menu2"
                        :close-on-content-click="false"
                        :nudge-right="0"
                        lazy
                        transition="scale-transition"
                        offset-y
                        :nudge-bottom="0"
                        full-width
                        max-width="290px"
                        min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                            v-model="download_date_end"
                            label="End Range"
                            hint="YYYY-MM-DD format"
                            prepend-icon="event"
                            v-on="on"

                    ></v-text-field>
                  </template>
                  <v-date-picker
                          v-model="download_date_end"
                          no-title
                          @input="download_date_menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

            </v-layout>
          </v-container>


          <v-layout row v-if="form_error_download">
            <!--<v-flex grow></v-flex>-->
            <v-spacer></v-spacer>
            <v-flex shrink class="pr-3 red--text"> {{form_error_download}}</v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="close_download_dialog">Cancel</v-btn>
          <v-btn color="primary" @click="download_file">Download</v-btn>
        </v-card-actions>
        <v-progress-linear v-if="submit_download_file" :indeterminate="true"  color="primary"></v-progress-linear>
      </v-card>
    </v-dialog>
















    <!------------delete grade dialog---------------------------------------------------------------------------------->
    <v-dialog
            v-model="dialog_delete_grade"
            max-width="400"
    >
      <v-card>
        <v-card-title class="headline">Confirm Delete Grade?</v-card-title>

        <v-card-text>
          Are you sure you want to delete this graded lead?  This action is irreversible.
        </v-card-text>

        <v-card-actions>
          <v-btn color="red" text @click="delete_graded_lead(del_grade_id)">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="close_del_confirm">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>




















    <!------------main data tables------------------------------------------------------------------------------------->
    <v-container fluid>

      <v-layout wrap>
        <v-btn @click="open_download_dialog('Leads')" color="accent">Download Leads</v-btn>
         <v-btn @click="open_download_dialog('Coach Ups')" color="accent">Download Coachups</v-btn>

        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md3>
          <v-menu
                  v-model="date_menu1"
                  :close-on-content-click="false"
                  :nudge-right="0"
                  lazy
                  transition="scale-transition"
                  offset-y
                  nudge-bottom="30"
                  full-width
                  max-width="290px"
                  min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="date_month"
                      label="Pick Month To View"
                      prepend-icon="event"
                      v-on="on"

              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="date_month"
                    @input="date_menu1 = false"
                    no-title
                    type="month"
                    v-on:change="on_change_month"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>




      <v-layout wrap>


        <!----------------------card for overall dealer grade-------------------------------------------------------->
        <v-flex xs12 sm4 >
          <v-card>
            <v-toolbar color="transparent" flat>
              <v-toolbar-title>Grading Progress for {{date_month_formatted}}</v-toolbar-title>
              <!--<v-spacer></v-spacer>-->
              <!--<v-btn icon>-->
              <!--<v-icon>more_horiz</v-icon>-->
              <!--</v-btn>-->
            </v-toolbar>
            <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
            <v-card-text class="text-xs-center">
              <v-progress-circular
                      :value="month_percent*100"
                      color="#ab96dc"
                      :rotate="180"
                      :size="250"
                      :width="10"
              >
                <v-progress-circular
                        :value="lead_totals.graded_percent*100"
                        :color="progress_color"
                        :rotate="180"
                        :size="231"
                        :width="18"
                >
                  <span class="progress-txt" :class="progress_class"><strong>Graded: {{round(lead_totals.graded_percent*100, 1)}}%</strong> </span><br>
                  <span class="percent-month"><strong> Month: {{round(month_percent*100, 1)}}%</strong> </span><br>
                  <span class="grey--text"></span>
                </v-progress-circular>

                <!--<span class="grade-card"><strong>{{round(lead_totals.graded_percent*100, 1)}}%</strong> </span><br>-->
                <!--<span class="grey&#45;&#45;text"></span>-->
              </v-progress-circular>
              <!--<div class="title my-2">Percent of Leads Graded for Month</div>-->
              <!--<span class="subheading grey&#45;&#45;text">{{date_month}}</span>-->

              <div class="progress-txt pt-4" :class="progress_class"><strong>Total Graded: {{lead_totals.leads_graded}}</strong> </div>
              <div class="progress-txt" ><strong>Total Leads: {{lead_totals.leads_total}}</strong> </div>
            </v-card-text>
          </v-card>
        </v-flex>


        <!---------------------------card to list summaries by dealerships--------------------------------------------->
        <v-flex xs12 sm8 class="pl-2">
          <v-card max-height="500px" style="overflow: auto" >
            <v-toolbar color="transparent" flat>
              <v-toolbar-title>MTD Progress</v-toolbar-title>
            </v-toolbar>
            <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
            <v-card-text class="text-xs-left">

              <v-data-table
                      :headers="headers_leads_summary"
                      :items="leads_summary"
                      :pagination.sync="agg_pagination"

              >
                <template slot="items" slot-scope="props" >
                  <tr
                          :key="props.item._id"
                          class="row_style"
                          :class="row_highlight(props.item)"
                          style="cursor:pointer;"
                          @click="on_select_dealership(props.item)"
                  >
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.leads_total}}</td>
                    <td>{{ props.item.leads_graded}}</td>
                    <td>{{ round(props.item.leads_percent_complete*100, 0)}}%</td>
                    <td>{{ round(props.item.leads_expected, 0)}}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>


      <!------------------------------list of individual graded leads------------------------------------------------>
      <v-layout v-if="selectedDealership!==null" class="mt-4">
        <v-flex xs12>
          <v-card>
            <v-toolbar color="transparent" flat>
              <v-toolbar-title>Graded Leads For: {{selectedDealership ? selectedDealership.name : ''}}</v-toolbar-title>
            </v-toolbar>
            <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
            <v-card-text class="text-xs-left">

              <v-data-table
                      :headers="gl_headers_admin"
                      :items="graded_leads"
                      :rows-per-page-items="rowsPerPage"

              >
                <template slot="items" slot-scope="props" >
                  <tr  v-on:click="view_this_grade(props.item)" style="cursor:pointer;"
                       :style="is_draft(props.item)? 'background-color:yellow':''">
                    <td>{{ props.item.info_lead.lead_arrived_date }}</td>
                    <td>{{ props.item.date_graded.slice(0, 10) }}</td>
                    <td>{{ props.item.curriculum.name }}</td>
                    <td>{{ props.item.grade_letter }}</td>
                    <td>{{ round(props.item.grade_score, 1) }}</td>
                    <td>{{ props.item.info_customer.name_first +' ' + props.item.info_customer.name_last}}</td>
                    <td>{{ props.item.info_lead.wanted_vehicle }}</td>
                    <td>{{ truncate_str(props.item.comments_external) }}</td>
                    <td >
                      <!--<v-icon small color="error" @click.stop="del_grade(props.item)">delete</v-icon>-->

                       <div style="display: flex; ">
                          <v-icon small color="primary" @click.stop="edit_this_grade(props.item)">edit</v-icon>

                          <v-icon small color="error" @click.stop="del_grade(props.item)" >
                             delete
                          </v-icon>
                       </div>


                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

        </v-flex>

      </v-layout>


    </v-container>

  </div>
</template>


<style scoped>

  .progress-txt{
    font-size: medium;
  }
  .percent-good{
    color: green;
  }
  .percent-bad{
    color: red;
  }
  .percent-ok{
    color: #ffc401;
  }


  .percent-month{
    color: #512da8;
    font-size: medium;
  }


  .row-bad{
    background-color: rgba(255, 0, 0, 0.20);
  }
  .row-ok{
    background-color: rgba(255, 255, 0, 0.20);
  }

  .row-good{
    background-color: rgba(0, 128, 0, 0.20);
  }


</style>

<script>
   import data_getters from '../mixins/data_getters';
   import validate from '../mixins/validation';
   import {DateTime} from 'luxon';
   import viewGrade from '../components/viewGrade.vue';
   import axios from 'axios';
   import editGrade from "@/views/Curricula/GradeLead";

   export default {
      mixins: [data_getters, validate],
      components: {viewGrade, editGrade},
      data() {
         return {
            download_type: 'Leads',

            date_month: null,
            date_menu1: false,

            date_month_formatted: 'month',
            month_percent: 0,
            lead_totals: {graded_percent:0},


            headers_leads_summary: [
               {text: 'Dealership', value: 'name', width: '30%'},
               {text: 'Total', value: 'leads_total', width: '10%'},
               {text: 'Graded', value: 'leads_graded', width: '10%'},
               {text: '% Complete', value: 'leads_percent_complete', width: '10%'},
               {text: 'Expected Graded', value: '', width: '10%'},
            ],

            leads_summary: [],
            agg_pagination: {
               sortBy: 'name', // The field that you're sorting by
               descending: false,
               rowsPerPage: -1
            },


            rowsPerPage: [10, 50, 100, {"text":"All","value":-1}],
            selectedDealership: null,
            graded_leads: [],

            gl_headers_admin: [
               {text: 'Date In', value: 'info_lead.lead_arrived_date', width: '10%'},
               {text: 'Date Graded', value: 'date_graded', width: '10%'},
               {text: 'Curriculum', value: 'curriculum.name', width: '5%'},
               {text: 'Grade', value: 'grade_letter', width: '5%'},
               {text: 'Score', value: 'grade_score', width: '5%'},
               {text: 'Customer', value: 'count', width: '15%'},
               {text: 'Vehicle', value: 'info_lead.wanted_vehicle', width: '15%'},
               {text: 'Comments', value: 'comments_external', width: '45%'},
               {text: '', value: '', width: '5%'},

            ],

            show_leads: true,
            showGrade: false,
            selectedLead: null,
            editGrade: false,

            //download data
            dialog_download: false,
            download_date_menu1: false,
            download_date_menu2: false,

            download_date_begin: null,
            download_date_end: null,
            form_error_download: null,

            submit_download_file: false,


            //delete grade
            dialog_delete_grade: false,
            del_grade_id: null,

         };
      },


      methods: {




         on_change_month(){
            this.get_admin_summary_local();
            this.selectedDealership = null;
         },

         async get_admin_summary_local() {
            let res = await this.get_admin_summary({month: this.date_month, groupby: 'dealerships'});
            this.leads_summary = res.data;
            this.month_percent = res.monthp;
            this.lead_totals = res.totals;

            this.date_month_formatted = DateTime.fromISO(this.date_month).toFormat('LLL yyyy');
         },


         on_select_dealership(item){
           this.selectedDealership = item;
            this.get_graded_leads_local();
         },

         async get_graded_leads_local(){

            let m = DateTime.fromISO(this.date_month); //note this defaults to the user's timezone
            let bdate  = m.startOf('month').toJSDate();
            let edate  = m.endOf('month').toJSDate();

            let dateRange = {begin: bdate, end: edate };

            try {
               if (this.selectedDealership !== null){
                  this.graded_leads = await this.get_graded_leads({dateRange, dealer_id: this.selectedDealership._id, });
               }

            }
            catch(err){
               console.log(err);
               // ans = err.response.data;
            }
         },

         view_this_grade(grade){
            this.selectedLead = grade;
            this.showGrade=true;


         },


         //******download data*********************

         open_download_dialog(download_type){

            if (!['Leads', 'Coach Ups'].includes(download_type) ){
               throw Error('invalid download type')
            }

            this.download_type = download_type;
            this.dialog_download=true;


         },

         async download_file(){
            this.submit_download_file = true;
            try{
               let dateRange = {begin: this.download_date_begin, end: this.download_date_end};

               let res, save_name;
               if (this.download_type==='Leads'){
                  save_name = 'lead_data.csv';
                  res = await this.get_graded_leads_csv({dateRange});
               }else{
                  save_name = 'coachup_data.csv';
                  res = await this.get_coachups_csv({dateRange});
               }


               const url = URL.createObjectURL(new Blob([res.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', save_name );
               document.body.appendChild(link);
               link.click();
               this.dialog_download=false;
            }
            catch(err){
               this.show_error_details(err, 'download_file()')
            }

            this.submit_download_file = false;
         },

         close_download_dialog(){
            this.dialog_download=false;
            this.submit_download_file = false;

         },

         set_download_dates(){
            let m = DateTime.fromISO(this.date_month); //note this defaults to the user's timezone
            let bdate  = m.startOf('month').toISODate().slice(0,10);
            let edate  = m.endOf('month').toISODate().slice(0,10);

            this.download_date_begin = bdate;
            this.download_date_end = edate;
         },



         // //******download data coachup*********************
         //
         // async download_file_cu(){
         //    this.submit_download_file_cu = true;
         //    try{
         //       let save_name = 'coachup_data.csv';
         //       let dateRange = {begin: this.download_date_begin, end: this.download_date_end};
         //
         //       let res = await this.get_coachups_csv({dateRange});
         //
         //       const url = URL.createObjectURL(new Blob([res.data]));
         //       const link = document.createElement('a');
         //       link.href = url;
         //       link.setAttribute('download', save_name );
         //       document.body.appendChild(link);
         //       link.click();
         //       this.dialog_download=false;
         //    }
         //    catch(err){
         //       this.show_error_details(err, 'download_file()')
         //    }
         //
         //    this.submit_download_file_cu = false;
         // },
         //
         // close_download_dialog_cu(){
         //    this.dialog_download_cu=false;
         //    this.submit_download_file_cu = false;
         //
         // },
         //
         // set_download_dates_cu(){
         //    let m = DateTime.fromISO(this.date_month); //note this defaults to the user's timezone
         //    let bdate  = m.startOf('month').toISODate().slice(0,10);
         //    let edate  = m.endOf('month').toISODate().slice(0,10);
         //
         //    this.download_date_begin = bdate;
         //    this.download_date_end = edate;
         // },
         //






         //*******color coding results*********************
         how_are_we_doing(p_grades, p_month){

            let ans;
            if (p_grades < p_month - 0.10)
               ans = 'bad';
            else if (p_grades < p_month - 0.05)
               ans = 'ok';
            else if (p_grades < p_month + 0.15)
               ans = 'good';
            else
               ans = 'bad';

            return ans;
         },


         /**
          * returns css class name to apply to row
          * @param item : item in array returned from get_admin_summary()
          */
         row_highlight(item){
            let ans = this.how_are_we_doing(item.leads_percent_complete, this.month_percent);
            let map = {
               bad: 'row-bad',
               ok: 'row-ok',
               good: 'row-good'
            };
            if (item.leads_total === 0)
               return '';
            else
              return map[ans];


         },


         //********delete grade*********************
         async delete_graded_lead( grade_id){
            console.log('grade', grade_id)
            let {token, query} = await this.base_user_request();
            let url = this.$baseUrlApi + '/deleteGradedLead';

            query.grade_id = grade_id;


            try {

               let res = await axios.post(url, {query }, token);
               this.dialog_delete_grade = false;
               this.del_grade_id = null;

               this.get_admin_summary_local();
               await this.get_graded_leads_local();

            }
            catch(err){
               this.show_error_details(err, 'delete_graded_lead()')

            }
         },

         del_grade(grade){

            this.del_grade_id = grade._id;
            this.dialog_delete_grade = true;
         },

         close_del_confirm(){
            this.dialog_delete_grade = false;
            this.del_grade_id = null;
         },


         edit_this_grade(grade){
            this.selectedLead = grade;
            this.editGrade = true;
         },
         close_edit_dialog(){
            this.editGrade=false;
            this.selectedLead=null;
            this.get_graded_leads_local();
         },

         //simple function to tell if a grade is a draft or not.  needed since we added the date_email field on 3/1/2021
         is_draft(lead) {

            // note this needs to be an exact match to handle the case of date_emailed not being defined
            return  (lead.emailed_users === null);

         },


      },
      computed:{

         progress_color(){

            let ans = this.how_are_we_doing(this.lead_totals.graded_percent, this.month_percent);
            let map = {
               bad: 'red',
               ok: 'yellow',
               good: 'green'
            };

            return map[ans];

         },

         progress_class(){
            let ans = this.how_are_we_doing(this.lead_totals.graded_percent, this.month_percent);
            let map = {
               bad: 'percent-bad',
               ok: 'percent-ok',
               good: 'percent-good'
            };

            return map[ans];

         }
      },

      watch: {
         dialog_delete_grade(newVal, oldVal){
            if (newVal === false)
               this.del_grade_id = null;
         }
      },


      created(){

         let d = new Date();
         this.date_month = d.toISOString().slice(0, 7);
         this.get_admin_summary_local();
         this.set_download_dates();
      }
   };
</script>

